import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    return;
  }

  const buildMode = process.env.REACT_APP_BUILD_MODE || '';
  const environment = buildMode.toLowerCase() || 'unknown';
  const isMainnet = environment === 'mainnet';

  if (!isMainnet || window.location.hostname === 'localhost') {
    return;
  }

  Sentry.init({
    dsn,
    environment,
    release: `lpbonds-webapp@${process.env.REACT_APP_VERSION || '0.0.0'}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[500, 599]],
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    ignoreErrors: [
      'ResizeObserver loop',
      'Non-Error promise rejection',
      /^Load failed$/,
      /^Failed to fetch$/,
      'ChunkLoadError',
    ],
    denyUrls: [/extensions\//i, /^chrome-extension:\/\//, /^moz-extension:\/\//],
  });
}
